import React from 'react';
import { Modal, Typography, Alert, Space, Form, Input, Button } from 'antd';
import { t } from '../../../utils/i18n';

type CaptureTaxIDForm = {
  tax_id: string;
};

export function PaymentCaptureTaxIDModal({
  isLoadingShorePayOnlineSetup,
  OnClickClose,
  onFormSubmit,
}: {
  isLoadingShorePayOnlineSetup: boolean;
  OnClickClose: () => void;
  onFormSubmit: (form: { taxId: string }) => void;
}) {
  const [form] = Form.useForm<CaptureTaxIDForm>();

  const handleOnFormSubmit = (submittedForm: CaptureTaxIDForm) => {
    onFormSubmit({ taxId: submittedForm.tax_id });
  };

  return (
    <Modal
      open
      onCancel={OnClickClose}
      title={t('application-settings.payments.capture-tax-modal.title')}
      footer={
        <Space wrap size="small" direction="horizontal">
          <Button
            key="s"
            size="middle"
            type="primary"
            htmlType="submit"
            form="capture_tax_id_form"
            data-testid="continue_capture_tax_id_button"
            loading={isLoadingShorePayOnlineSetup}
            disabled={isLoadingShorePayOnlineSetup}
          >
            {t(
              'application-settings.payments.capture-tax-modal.form.button-continue'
            )}
          </Button>
        </Space>
      }
    >
      <Space direction="vertical" size="middle">
        <Typography.Text>
          {t('application-settings.payments.capture-tax-modal.description')}
        </Typography.Text>
        <Alert
          type="warning"
          message={t('application-settings.payments.capture-tax-modal.warning')}
        />
        <Form
          form={form}
          layout="vertical"
          autoComplete="off"
          id="capture_tax_id_form"
          onFinish={handleOnFormSubmit}
        >
          <Form.Item
            name="tax_id"
            label={t(
              'application-settings.payments.capture-tax-modal.form.input-label'
            )}
            rules={[
              {
                required: true,
                message: t(
                  'application-settings.payments.capture-tax-modal.form.errors.validation.required'
                ),
              },
              {
                pattern: /^[a-zA-Z0-9]+$/,
                message: t(
                  'application-settings.payments.capture-tax-modal.form.errors.validation.only-letters-numbers'
                ),
              },
            ]}
          >
            <Input
              placeholder={t(
                'application-settings.payments.capture-tax-modal.form.input-placeholder'
              )}
            />
          </Form.Item>
        </Form>
      </Space>
    </Modal>
  );
}
